import Discord from '@/assets/website/discord.svg';
import Twitter from '@/assets/website/twitter.svg';
import Typography from '@/components/typography';

export default function HowInvolve() {
  return (
    <div className="mx-4 flex-wrap content-center items-center justify-center">
      <div
        className="m-auto my-40 max-w-3xl rounded-[62px] bg-white p-20"
        style={{ boxShadow: '0px 2px 50px 0 #eff1f1' }}
      >
        <p className="mx-4 mb-16 text-center text-3xl font-bold text-[#4e4e4e]">
          How can I get involve?
        </p>
        <div className="flex w-full content-center items-center justify-start">
          <a
            href="https://discord.gg/Bg8Xz7YXWt"
            target="_blank"
            rel="noreferrer noopener"
            className="w-1/2 content-center items-center justify-start"
          >
            <img alt="" className="m-auto" src={Discord} />
            <Typography
              variant="subTitle"
              className="mt-5 text-center text-lg font-bold text-[#7adcae]"
            >
              Join Community
            </Typography>
          </a>
          <a
            href="https://twitter.com/vitae3me"
            target="_blank"
            rel="noreferrer noopener"
            className="w-1/2 content-center items-center justify-start"
          >
            <img alt="" className="m-auto" src={Twitter} />
            <Typography
              variant="subTitle"
              className="mt-5 text-center text-lg font-bold text-[#7adcae]"
            >
              Follow Twitter
            </Typography>
          </a>
        </div>
      </div>
    </div>
  );
}
